import { Close as CloseIcon } from '@mui/icons-material'
import { Button, DialogActions, DialogContent, DialogTitle, Grid, Typography, useTheme } from '@mui/material'
import { useTranslation } from 'react-i18next'
import CustomSnackBar from '../../../../../shared/components/CustomSnackBar'
import { CancelButton, SaveButton } from '../../../../../shared/components/inputs'
import TabPanel from '../../../../../shared/components/TabPanel'
import { formsStyles } from '../../../../../shared/styles/FormsStyles'
import { useNoveltyModal } from '../../hooks/useNoveltyModal'
import NoveltyAddonsTab from './NoveltyAddonsTab'
import NoveltyGeneralTab from './NoveltyGeneralTab'
import NoveltyHeaderFields from './NoveltyHeaderFields'
import useTabState from '@/contexts/shared/hooks/useTabState'
import { StyledDialog } from '@/contexts/shared/styles/StyledDialog'
import { StyledTabs } from '@/contexts/shared/components/StyledTabs'
import { CustomTab } from '@/contexts/backoffice/users/ui/components/modals/create/CustomTab'

function NoveltyModal() {
  const { t } = useTranslation(['global'])
  const theme = useTheme()
  const formClasses = formsStyles(theme)
  const { currentTab, setCurrentTab, a11yProps } = useTabState()

  const {
    noveltyState,
    msgCopy,
    showForm,
    errorForm,
    errorTab,
    isValidForm,
    handleInputChange,
    handleCloseNoveltyModal,
    handleSubmit,
    handleCopyText,
    STATUS,
    VISIBILITY
  } = useNoveltyModal()

  return (
    <StyledDialog
      open={showForm}
      onClose={handleCloseNoveltyModal}
      aria-labelledby="novelty-dialog-title"
      aria-describedby="novelty-dialog-des"
      disableEnforceFocus
    >
      <DialogTitle id="novelty-dialog-title">
        <Grid container justifyContent="space-between">
          <Typography variant="h6">{`${t('create')} ${t('update')}`}</Typography>
          <Button onClick={handleCloseNoveltyModal} color="primary" variant="text">
            <CloseIcon />
          </Button>
        </Grid>
      </DialogTitle>
      <DialogContent sx={{ pb: 3, pt: 2 }}>
        <NoveltyHeaderFields novelty={noveltyState} handleInputChange={handleInputChange} />
        <Grid item xs={12}>
          <StyledTabs value={currentTab} onChange={(_, value) => setCurrentTab(value)} aria-label="novelty tabs">
            <CustomTab label={t('general')} {...a11yProps(0)} error={errorTab.general} />
            <CustomTab label={t('add-ons')} {...a11yProps(1)} error={errorTab.addOn} />
          </StyledTabs>
        </Grid>
        <TabPanel value={currentTab} index={0}>
          <NoveltyGeneralTab novelty={noveltyState} handleInputChange={handleInputChange} STATUS={STATUS} VISIBILITY={VISIBILITY} />
        </TabPanel>
        <TabPanel value={currentTab} index={1}>
          <NoveltyAddonsTab novelty={noveltyState} handleInputChange={handleInputChange} handleCopyText={handleCopyText} />
        </TabPanel>
      </DialogContent>
      <DialogActions sx={!isValidForm && Object.keys(errorForm).length > 0 ? formClasses.errorDialogActions : {}}>
        <CancelButton onClick={handleCloseNoveltyModal}>{t('cancel')}</CancelButton>
        <SaveButton onClick={handleSubmit}>{t('save')}</SaveButton>
      </DialogActions>
      <CustomSnackBar errors={[false]} msgs={[msgCopy]} />
    </StyledDialog>
  )
}

export default NoveltyModal
